// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderTotalDisplaySharedStyles } from "@conklin/App/SharedStyles/MyAccountPages/Details/OrderTotalDisplaySharedStyles";
import { quickOrderTotalStyles } from "@conklin/App/Widgets/QuickOrder/QuickOrderTotal";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color, mergeWithCss } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

quickOrderTotalStyles.wrapper = {
    ...mergeWithCss(orderTotalDisplaySharedStyles.wrapper, {
        css: css`
            flex-direction: column;
        `,
    }),
};
quickOrderTotalStyles.title = {
    variant: "h3",
    css: css`
        width: 100%;
        padding-bottom: 12px;
        margin-bottom: 12px;
        border-bottom: 1px solid ${color("common.border")};
    `,
};
quickOrderTotalStyles.totalWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
    `,
};
quickOrderTotalStyles.totalValue = {
    weight: fontConfig.weight.bold,
};
quickOrderTotalStyles.buttonsWrapper = {
    css: css`
        > div:first-child {
            display: flex;
            flex-direction: column-reverse;
            padding-top: 12px;
            border-top: 1px solid ${color("common.border")};
            margin-top: 12px;
            &:empty {
                display: none;
            }
        }
    `,
};
